import http from '../api/http'

export const parseUserEmail = (): string => {
    try {
        const userData = JSON.parse(localStorage.user)
        return userData?.user?.email || userData?.email || ''
    } catch (error) {
        console.error('Error parsing user data from localStorage:', error)
        return ''
    }
}

export const parseActiveEmails = (emails: string): string[] => {
    return (emails || '').split('\n').map(email => email.trim()).filter(Boolean)
}

export async function checkIsEditor(): Promise<boolean> {
    try {
        const response = await http.get('/api/core/config');
        const emailsRaw = response?.data?.data?.items?.[0]?.activeEmails || response?.data?.data?.[0]?.activeEmails || response?.data?.data?.activeEmails || [];
        let emailsArray: string[] = [];
        if (Array.isArray(emailsRaw)) {
            emailsArray = emailsRaw;
        } else if (typeof emailsRaw === 'string') {
            emailsArray = parseActiveEmails(emailsRaw);
        }
        const userEmail = parseUserEmail();
        return emailsArray.includes(userEmail) && emailsArray.length > 0;
    } catch (error) {
        return false;
    }
} 